import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Alert } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
export default function OrderError() {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(Alert, {
    message: __('Unable to retrieve your order.'),
    intent: "danger"
  });
}